<template>
    <div id="container-development-section">
        <Swiper 
        :slidesPerView="'auto'"
        :centeredSlides="false"
        :spaceBetween="30"
        :modules="modules"
        :speed="1000"
        :pagination="{
            clickable: true,
        }"
        :grabCursor="true"
        :shortSwipes="true"
        :longSwipesRatio="0.1"
        :threshold="5"
        class="mySwiper m-0">
            <template v-for="(image, index) in Frontend" :key="index">
                <SwiperSlide>
                    <div 
                        :id="image.imageId" 
                        class="container-img clickable-card"
                        @click="handleCardClick(image.link)"
                        @touchstart="handleTouchStart"
                        @touchend="handleTouchEnd(image.link, $event)"
                        @keydown.enter="handleCardClick(image.link)"
                        @keydown.space="handleCardClick(image.link)"
                        tabindex="0"
                        role="button"
                        aria-label="Ver proyecto {{ image.txtLink }}"
                    >
                        <PictureStructure 
                        :altImg="image.altImg"
                        :srcAvif="image.srcAvif"
                        :srcAvif320="image.srcAvif320"
                        :srcAvif480="image.srcAvif480"
                        :srcAvif768="image.srcAvif768"
                        :srcAvif1080="image.srcAvif1080"
                        :srcWebp="image.srcWebp"
                        :srcWebp320="image.srcWebp320"
                        :srcWebp480="image.srcWebp480"
                        :srcWebp768="image.srcWebp768"
                        :srcWebp1080="image.srcWebp1080"
                        :srcPng="image.srcPng"
                        :srcPng320="image.srcPng320"
                        :srcPng480="image.srcPng480"
                        :srcPng768="image.srcPng768"
                        :srcPng1080="image.srcPng1080"
                        :srcJpg="image.srcJpg"
                        :srcJpg320="image.srcJpg320"
                        :srcJpg480="image.srcJpg480"
                        :srcJpg768="image.srcJpg768"
                        :srcJpg1080="image.srcJpg1080"
                        classes="img-height" />
                        <div class="text-information">
                            <p v-html="formatDescription(image.description)" class="description-img"></p>
                            <div class="link">
                                <a class="more">{{ image.txtLink }}</a>
                                <i class="ri-arrow-right-up-line"></i>
                            </div>
                        </div>
                    </div>
                </SwiperSlide> 
            </template>
        </Swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { FreeMode, Autoplay, Pagination } from 'swiper/modules';
import PictureStructure from '@/components/PictureStructure.vue';
import DOMPurify from 'dompurify';
import Frontend from './frontend.js'

export default {
    name: 'PortfolioDevelopment',
    components: {
        Swiper, SwiperSlide, PictureStructure, 
    },
    setup() {
        return {
            modules: [FreeMode, Autoplay, Pagination],
        };
    },
    data() {
        return {
            Frontend,
            touchStartX: 0,
            touchStartY: 0,
            touchStartTime: 0,
        }
    },
    methods: {
        formatDescription(description) {
            const cleanHTML = DOMPurify.sanitize(description);
            return cleanHTML;
        },
        handleCardClick(link) {
            window.open(link, '_blank');
        },
        handleTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
            this.touchStartY = event.touches[0].clientY;
            this.touchStartTime = Date.now();
        },
        handleTouchEnd(link, event) {
            const touchEndX = event.changedTouches[0].clientX;
            const touchEndY = event.changedTouches[0].clientY;
            const touchEndTime = Date.now();
            
            const deltaX = Math.abs(touchEndX - this.touchStartX);
            const deltaY = Math.abs(touchEndY - this.touchStartY);
            const deltaTime = touchEndTime - this.touchStartTime;
            
            if (deltaX < 10 && deltaY < 10 && deltaTime < 300) {
                event.preventDefault();
                window.open(link, '_blank');
            }
        },
    },
}
</script>

<style scoped>
.clickable-card {
    cursor: pointer;
    transition: all 0.2s ease;
    height: 100%;
    position: relative;
    -webkit-tap-highlight-color: transparent;
}

.clickable-card:hover {
    transform: translateY(-2px);
}

.clickable-card:active {
    transform: translateY(0);
}
</style>

<style scoped>
#container-development-section{
    margin-top: 3vh;
    width: 95vw;
}
.container-img{
    width: min-content;
    border: var(--white) 1px solid;
}
.description-img{
    margin: 1vh 0 0 0;
}
.link{
    border-left: var(--white) 1px solid;
}
.text-information{
    display: flex;
    align-items: center;
    border-top: var(--white) 1px solid;
    justify-content: space-between;
    position: relative;
    z-index: 2;
}
.text-information p{
    margin: 0;
    font-size: 2.4vh;
}
.link{
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.5s ease-in-out;
}
.link .more{
    transition: all 0.5s ease-in-out;
    text-decoration: none;
    color: var(--black);
    background-color: var(--white);
    position: absolute;
    left: 0;
    font-family: var(--font-monospace);
    text-transform: uppercase;
    width: 0px;
    overflow: hidden;
    display: flex;
    align-items: center;
    white-space: nowrap;
}
.no-decoration{
    text-decoration: none;
    color: var(--white);
}
.link .ri-arrow-right-up-line{
    font-size: 3.2vh;
    padding: 0 2vh;
    transition: all 0.5s ease-in-out;
    position: relative;
    z-index: 1;
}
.link:hover{
    background-color: var(--white);
    border-left: var(--black) 1px solid;
}
.link:hover .ri-arrow-right-up-line{
    color: var(--black);
    padding: 0 3vh;
}
.link:hover a{
    width: 100%;
    padding-left: 2vh;
}
@media only screen and (orientation: portrait){
    .text-information p{
        padding: 2vw;
        font-size: 2.1vh;
    }
    .text-information, .link, .link .more{
        height: 12vh;
    }
}
@media only screen and (orientation: landscape){
    #container-development-section{
        height: 80vh;
    }
    .container-img{
        height: 80vh;
    }
    .text-information p{
        font-size: 2.4vh;
        padding: 0 1vw;
    }
    .text-information, .link, .link .more{
        height: 9vh;
    }
}
</style>


<style lang="scss">
#container-development-section {
    .swiper{
        overflow: visible;
        .swiper-slide{
            max-width: fit-content;
        }
        .swiper-slide:last-child{
            margin-right: 5vw;
        }
        .swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal {
            max-width: fit-content;
            .swiper-pagination-bullet {
                border-radius: 0;
                position: relative;
                bottom: -1vw;
            }
            .swiper-pagination-bullet-active{
                background-color: var(--main-color);;
            }
            :not(.swiper-pagination-bullet-active){
                background-color: var(--white);
                opacity: 0.6;
            }
        }
    }
}
@media only screen and (orientation: portrait){
    #container-development-section {
        .swiper{
            .swiper-slide{
                .img-height{
                    height: 90vw;
                }
            }
            .swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal {
                min-width: 90vw;
                position: relative;
                top: 1vh;
            }
        }
    }
}
@media only screen and (orientation : landscape){
    #container-development-section {
        .swiper{
            .swiper-slide{
                .img-height{
                    height: calc(100% - 9vh);
                }
            }
            .swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal {
                max-width: fit-content;
                transform: rotate(90deg);
                background-color: var(--black);
                position: absolute;
                left: -50.9vh;;
                bottom: 34.97vh;
                min-width: 89vh;
                height: 10.7vh;
            }
        }
    }
}
</style>